module.exports = __webpack_public_path__ + "static/media/academic calendar.7609f24b.svg";